import { atom, selector } from 'recoil';

import { DateRange } from '@mui/x-date-pickers-pro';

import { SelectedChip, ChipSelection, SelectedYearChip } from './enum';

const uniqueAtomKey = 'Realization_';

export const dateRangeAtom = atom<DateRange<Date | null>>({
  key: `${uniqueAtomKey}dateRange`,
  default: [null, null]
});

export const yearDateRangeAtom = atom<DateRange<Date | null>>({
  key: `${uniqueAtomKey}yearDateRange`,
  default: [null, null]
});

export const selectedChipAtom = atom<SelectedChip | ''>({
  key: `${uniqueAtomKey}selectedChip`,
  default: ''
});

export const selectedYearChipAtom = atom<SelectedYearChip | ''>({
  key: `${uniqueAtomKey}yearChip`,
  default: ''
});

export const canDownloadReportAtom = selector({
  key: `${uniqueAtomKey}downloadReport`,
  get: ({ get }) => {
    const selectedChip = get(selectedChipAtom);
    return [
      ChipSelection.LAST_MONTH,
      ChipSelection.THIS_MONTH,
      ChipSelection.NEXT_MONTH,
      ChipSelection.LAST_WEEK,
      ChipSelection.THIS_WEEK,
      ChipSelection.NEXT_WEEK
    ].includes(selectedChip as SelectedChip);
  }
});
